'use client';
import { featureFlags } from '@lib/constants/network-constants';
import { getFeatureFlagState } from '@lib/data';
import { useEffect } from 'react';
import { getLogger } from '@lib/util/logging-util';

const logger = getLogger();

const KLAVIYO_SCRIPT_URL = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=XuVyV3';

const checkKlaviyoTrackingEnabled = async (): Promise<boolean> => {
    try {
        return await getFeatureFlagState(featureFlags.KLAVIYO_TRACKING);
    } catch (error) {
        logger.error("Error checking Klaviyo Tracking state:", error);
        return false;
    }
};

const addKlaviyoScript = () => {
    if (document.querySelector(`script[src="${KLAVIYO_SCRIPT_URL}"]`)) {
        logger.debug("Klaviyo script is already added");
        return;
    }

    const klaviyoScript = document.createElement('script');
    klaviyoScript.setAttribute('src', KLAVIYO_SCRIPT_URL);
    klaviyoScript.async = true;
    klaviyoScript.type = 'text/javascript';

    klaviyoScript.onload = () => {
        logger.debug("Klaviyo script loaded successfully");
    };

    klaviyoScript.onerror = () => {
        logger.error("Failed to load Klaviyo script");
    };

    document.head.appendChild(klaviyoScript);
};

const KlaviyoTracking = () => {
    const checkKlaviyoTrackingEnabled = async (): Promise<boolean> => {
        try {
            return await getFeatureFlagState(featureFlags.KLAVIYO_TRACKING);
        } catch (error) {
            console.error("Error checking Klaviyo Tracking state:", error);
            return false;
        }
    };

    const addKlaviyoScript = () => {
        if (document.querySelector(`script[src="${KLAVIYO_SCRIPT_URL}"]`)) {
            console.log("Klaviyo script is already added.");
            return;
        }

        const klaviyoScript = document.createElement('script');
        klaviyoScript.setAttribute('src', KLAVIYO_SCRIPT_URL);
        klaviyoScript.async = true;
        klaviyoScript.type = 'text/javascript';

        klaviyoScript.onload = () => {
            console.log("Klaviyo script loaded successfully.");
        };

        klaviyoScript.onerror = () => {
            console.error("Failed to load Klaviyo script.");
        };

        document.head.appendChild(klaviyoScript);
    };

    useEffect(() => {
        const initializeKlaviyoTracking = async () => {
            const enabled = await checkKlaviyoTrackingEnabled();
            if (enabled) {
                addKlaviyoScript();
            }
        };

        initializeKlaviyoTracking();
    }, []);

    return null;
};

export default KlaviyoTracking;
